import { initializeConnector } from "@web3-react/core";
import { BowlineWallet } from "./lib/bowlineWallet";
import { WALLET_CONNECTORS, AUTH_CONNECTION } from "@web3auth/modal";

export const [bowlineWallet, hooks] = initializeConnector(
  (actions) =>
    new BowlineWallet({
      actions,
      options: {
        connector: WALLET_CONNECTORS.AUTH,
        connection: AUTH_CONNECTION.FACEBOOK,
      },
    })
);
